import { PAGE_SEO } from "./pageMeta";
import type { MarketingLang, MarketingPageId } from "./routes";
import { OG_IMAGE_PATH, pagePath } from "./routes";

export function organizationJsonLd(origin: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "OwnerFlow",
    url: origin,
    logo: `${origin}/assets/ownerflow/images/ownerflow-logo.png`,
    parentOrganization: {
      "@type": "Organization",
      name: "IntraPro",
    },
  };
}

export function softwareApplicationJsonLd(origin: string, lang: MarketingLang) {
  const seo = PAGE_SEO.home[lang];
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "OwnerFlow",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: `${origin}${pagePath("home", lang)}`,
    description: seo.description,
    offers: {
      "@type": "Offer",
      url: `${origin}${pagePath("pricing", lang)}`,
    },
  };
}

export function breadcrumbJsonLd(
  origin: string,
  lang: MarketingLang,
  crumbs: Array<{ id: MarketingPageId; name: string }>,
) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: `${origin}${pagePath(crumb.id, lang)}`,
    })),
  };
}

export function faqJsonLd(questions: Array<{ question: string; answer: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export { OG_IMAGE_PATH };
